import { useTranslation } from 'react-i18next';
import wheelModal1x from '../assets/wheel-modal.webp?w=120&format=webp&quality=70&imagetools';
import wheelModal2x from '../assets/wheel-modal.webp?w=240&format=webp&quality=60&imagetools';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onSpinNow: () => void;
}

export default function LuckyWheelPromoModal({ isOpen, onClose, onSpinNow }: Props) {
	const { t } = useTranslation();
	if (!isOpen) return null;

	return (
		<div className="fixed inset-0 z-50 flex min-h-screen items-center justify-center bg-black/70 backdrop-blur-sm p-4 sm:p-6" role="dialog" aria-modal="true" aria-labelledby="wheel-promo-title">
			<div className="w-full max-w-sm sm:max-w-md bg-gray-900 rounded-lg sm:rounded-xl shadow-2xl border border-pink-600/20 relative">
				<button
					type="button"
					onClick={onClose}
					aria-label="Close"
					className="absolute top-3 right-3 inline-flex items-center justify-center w-8 h-8 rounded-full text-gray-400 hover:text-white hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-pink-600/50"
				>
					×
				</button>
				<div className="px-5 sm:px-6 py-5 text-center">
					<img
						src={wheelModal1x}
						srcSet={`${wheelModal1x} 1x, ${wheelModal2x} 2x`}
						alt="Τροχός δώρων 210 Tattoo Athens"
						aria-hidden
						className="object-contain mb-4 inline-block"
						width={120}
						height={120}
					/>
					<h3 id="wheel-promo-title" className="text-xl font-semibold text-white mb-2">
						{t('promo.wheel.title')}
					</h3>
					<p className="text-sm text-gray-300 mb-6">
						{t('promo.wheel.body')}
					</p>
					<div className="grid grid-cols-1 gap-3">
						<button
							onClick={onSpinNow}
							className="w-full bg-gradient-to-r from-pink-600 to-pink-700 hover:from-pink-700 hover:to-pink-800 text-white font-semibold rounded-md py-2"
						>
							{t('promo.wheel.spinNow')}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}


